import { useEffect, useState } from "react";
import Typewriter from 'typewriter-effect';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { SignupModelHelper } from "../data/SignupModel";
import { AmplitudeService } from '../services/AmplitudeService';

export default function EstadoCivil(props: any) {

  const [lastAnswer, setLastAnswer] = useState('');
  const maritalStatusOptions = [
    { description: 'Casado(a)', value: 'CA' },
    { description: 'Divorciado(a)', value: 'DI' },
    { description: 'Separado(a)', value: 'SE' },
    { description: 'Solteiro(a)', value: 'SO' },
    { description: 'Viúvo(a)', value: 'VI' }
  ]


  const [typed, setTyped] = useState(false);
  const [interactions, setInteractions] = useState<InteractionModel[]>([]);

  useEffect(() => {

    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });

    const signup = SignupModelHelper.get();
    if (signup) {
      setLastAnswer(signup.deficiency?.name!);
    } else {
      document.location = '#/';
    }

    // TagManager.dataLayer(dataLayerHelper.pagina('estado-civil', 'curriculo'));
    AmplitudeService.track('Marital Screen')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateMaritalStatusExpectation(value: string) {
    const maritalStatus = !value ? undefined : maritalStatusOptions.find((msOption) => msOption.value === value);
    SignupModelHelper.update({ maritalStatus });
    AmplitudeService.track('Marital Submit', { marital_type: maritalStatus })
    document.location = '#/nacionalidade';
  }

  return (
    <>
      <Header step={ 2 } total={ 3 } title="Seu estado civil" previous="#/deficiencia"></Header>
      <div className="chat-container">
        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                <div className="chat-item chat-item-user">
                  <img src="images/ico-chat-user.svg" alt="Usuário" />
                  <div className="chat-item-content">
                    <p>{ lastAnswer }</p>
                  </div>
                </div>

                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <Typewriter
                      onInit={ (typewriter) => {
                        typewriter
                          .changeDelay(15)
                          .typeString(`Qual é o seu estado civil?`)
                          .callFunction(() => {
                            setTyped(true)
                          })
                          .start();
                      } }
                    />
                  </div>
                </div>

                {
                  interactions.map((interaction) => {
                    let objRet;

                    if (interaction.author === InteractionAuthor.AMARELINHO) {
                      objRet = <div className="chat-item" key={ interactions.indexOf(interaction) }>
                        <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                        <div className="chat-item-content">
                          <Typewriter
                            onInit={ (typewriter) => {
                              typewriter.changeDelay(15).typeString(interaction.text)
                                .start();
                            } } />
                        </div>
                      </div>

                    } else if (interaction.author === InteractionAuthor.CLIENTE) {
                      objRet = <div className="chat-item chat-item-user" key={ interactions.indexOf(interaction) }>
                        <img src="images/ico-chat-user.svg" alt="Usuário" />
                        <div className="chat-item-content">
                          <p>{ interaction.text }</p>
                        </div>
                      </div>
                    }

                    return objRet;
                  })
                }
              </div>
            </div>
          </div>
        </div>

        { typed &&
          <footer className="footer-answer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="footer-answer-holder d-flex align-items-center justify-content-between">
                    <select name="" className="select select-hidden" id="maritalStatus" onChange={ (e) => updateMaritalStatusExpectation(e.target.value) } >
                      <option>Escolha um estado civil</option>
                      {
                        maritalStatusOptions.map(maritalStatusOption => (
                          <option key={ maritalStatusOption.value } value={ maritalStatusOption.value }>{ maritalStatusOption.description }</option>
                        ))
                      }
                    </select>
                    <input type="text" name="" id="input" placeholder="Escolha uma opção" />
                    <button className="btn-submit" disabled >
                      <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0114286 20L24 10L0.0114286 0L0 7.77778L17.1429 10L0 12.2222L0.0114286 20Z"></path></svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        }
      </div>
    </>
  );
}

